exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NotDoneYetDialog-a7299ec9{position:relative;max-width:100%}.NotDoneYetDialog-a7299ec9 .video-c79ffbc1{width:100%;height:auto}\n", ""]);

// Exports
exports.locals = {
	"NotDoneYetDialog": "NotDoneYetDialog-a7299ec9",
	"video": "video-c79ffbc1"
};